module.exports = __webpack_public_path__ + "images/hero_mission2_2624e97bfe653f981052af19a0768af4.png";